<style scoped lang="scss">
.hardship-reason {
  font-size: 1.2em;
  margin-bottom: 8px;

  display: flex;

  .reason-text {

  }
}
.member-hardship-container {
  .member-title {
    font-size: 1.4em !important;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .member-section {
    margin-left: 0px;
  }
}
.label-large {
  font-size: 1.3em;
  margin-bottom: 25px;

  display: flex;
  input[type=checkbox] {
    transform: scale(1.3);
    margin-right: 6px;
  }
}

.checkbox-container {
  margin-right: 6px;
  height: 100%;
}

.vue-dropzone {
  background: #eee;
  border: thin dashed #666;
}
</style>

<template>
  <div class="uk-form" v-if="application">


    <div class="uk-grid uk-margin-top uk-margin-large-bottom">

      <div class="uk-width-1-1 uk-margin-bottom">
        <h2 class="uk-align-center">
          {{ application.program.program_abbreviation }} Financial Hardship Attestation
        </h2>
      </div>

      <div class="uk-width-1-1 member-hardship-container" v-for="(member, i) in hhMembers" v-if="i === 0 || programSettings['requires-all-household-members-hardship-information']">
        <!-- Covid Hardship -->
        <label class="label-large">
          <div>
            I/we attest that I/we have experienced a material reduction in income and/or a material increase in living expenses associated with the coronavirus pandemic that has created or increased a risk of mortgage delinquency, mortgage default, foreclosure, loss of utilities or home energy services, or displaced me/us as a homeowner(s), that this financial hardship occurred after January 21, 2020, and that the nature of the financial hardship is because of [check all that apply]:
          </div>
        </label>
        <div class="uk-grid uk-margin-bottom uk-margin-small-top member-section">
          <div class="uk-width-1-1">
            <div class="uk-grid">
              <div class="uk-width-1-1 hardship-reason" v-for="(reason, reasonKey) in reasons">
                <div class="checkbox-container">
                  <input type="checkbox" v-model="member.hardship_reasons" :value="reason.id">
                </div>
                <div class="checkbox-description">
                  <span class="reason-text">{{ reason.body }}</span>
                </div>
              </div>

              <div class="uk-width-1-1">
                <validated-section :errors="errors" field="reasons">
                  &nbsp;
                </validated-section>
              </div>
            </div>
          </div>

          <div class="uk-width-1-1 uk-margin-top">
            <validated-section :errors="errors" field="hardship_explanation">
              <label class="font-weight: bold">OTHER:</label>
              <textarea placeholder="Explain Your Hardship..." v-model="member.hardship_reason_explanation" class="uk-form-large uk-input uk-width-1-1"></textarea>
            </validated-section>
          </div>

        </div>
        <!-- / Housing Instability -->


      </div> <!-- End Member Loop -->
    </div>


    <div class="uk-grid" v-if="applicant">
      <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2">
        <p class="uk-">
          I certify that this statement is true and correct to the best of my knowledge, and I authorize the release of any or all information necessary for verification purposes.
        </p>
        <validated-section :field="'signature_'+applicant.id" :errors="errors">
          <signature-box @updated="onSignatureUpdated"
                         :user-key="applicant.id"
                         type-key="app-hardship"
                         :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
                         :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
                         :name="applicant.first_name + ' ' + applicant.last_name"
                         :color="programSettings['primary-program-color']"
          ></signature-box>
        </validated-section>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import ValidatedSection from "../../../../../components/Common/ValidatedSection";
import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
import VueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DropzoneUploader from "../../../../../components/AppWizard/Documents/DropzoneUploader";

export default {
  name: "FinancialHardshipAttestation",
  components: {DropzoneUploader, SignatureBox, ValidatedSection, VueDropzone},
  data() {
    return {
      errors: {},
      dropzoneOptions: {
        url: '/api/hope/documents',
        thumbnailWidth: 200,
        addRemoveLinks: true,
        maxFiles: 1,
        acceptedFiles: ['.pdf', '.png', '.jpg', '.jpeg'].join(','),
      },
      hardshipReasons: [],
      housingHardshipReasons: [],
      hardshipReasonsExplanations: '',
      housingHardshipReasonsExplanations: '',
      signatureData: {},
    }
  },
  computed: {
    ...mapState('Application', {
      application: state => state.application,
      applicant: state => state.applicant,
      hhMembers: state => state.application.household.members,
      reasons: state => state.assets.uapHardshipReasons,
      housingReasons: state => state.assets.housingReasons,
      signatures: state => state.applicant.signatures,
    }),
    ...mapState('App', {
      env: state => state.env,
    }),
    ...mapGetters('Application', [ 'programSettings' ]),
  },
  watch: {
    application(newValue) {
      if(newValue) {
        this.initData();
      }
    }
  },
  mounted() {
    if(this.application) {
      this.initData();
    }
  },
  methods: {
    initData() {
      const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `app-hardship`)
      if(signatureFiltered) {
        this.$set(this.signatureData, this.applicant.id, { signed_at: signatureFiltered.created_at, completed: true });
      }
    },

    addFinding(member) {
      member.finding_types.push({
        pivot: {
          finding_type_id: null,
          finding_type_level: null,
          household_application_id: this.application.id,
          household_member_id: member.id,
          household_id: member.household_id,
          notes: '',
        }
      })
    },

    formDataForMember(member) {
      return {
        household_application_id: this.application.id,
        household_member_id: member.id,
        applicant_user_id: this.application.applicant_user_id,
        file_type: 'proof_of_hardship',
      }
    },
    onMaxFilesExceeded(file) {
      console.log('max files exceeded', file);
    },
    onSignatureUpdated($event) {
      if(!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
    },
    async validateStep() {
      this.errors = {};
      let hasReasons = false;
      _.each(this.hhMembers, member => {
        if(member.hardship_reasons.length > 0) {
          hasReasons = true;
        }
        if(member.hardship_reason_explanation) {
          hasReasons = true;
        }
      })
      if(!hasReasons) {
          this.errors['reasons'] = { errors: ['You must provide at least one reason for hardship.']};
      }

      //
      if(!this.signatureData[this.applicant.id]) {
        this.errors['signature_'+this.applicant.id] = {
          errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
        };
      }else if(this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
        this.errors['signature_'+this.applicant.id] = {
          errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
        };
      }

      let errorCount = _.size(this.errors);

      if(errorCount > 0) return false;


      // Server Side Validation
      try {
        let response = await this.save();
        return true;
      }catch(err) {
        console.error(err);
      }

    },
    async save() {

      let _members = _.map(this.application.household.members, member => _.pick(member, [
        'id',
        'is_unemployed',
        'date_unemployed',
        'date_apply_unemployed',
        'date_award_unemployed',
        'date_reemployed',
        'experienced_covid_hardship',
        'hardship_reasons',
        'hardship_reason_explanation',
        'experienced_housing_instability',
        'housing_hardship_reasons',
        'housing_hardship_reason_explanation',
        'finding_types',
      ]))

      let data = {
        signatures: this.signatureData,
        members: _members,
      }
      return await axios.put(`/api/hope/applications/${this.application.id}/step-hardship-reason`, data)
    },
  }
}
</script>
